import {
  GET_WEBSITE_START,
  GET_WEBSITE_REQUEST,
  GET_WEBSITE_SUCCESS,
  GET_WEBSITE_FAIL,
  GET_WEBSITES_START,
  GET_WEBSITES_REQUEST,
  GET_WEBSITES_SUCCESS,
  GET_WEBSITES_FAIL,
  SET_DEALER,
} from '../constants';

export const getWebsites = (payload) => ({
  payload,
  type: GET_WEBSITES_REQUEST,
});
export const getWebsitesStart = (payload) => ({
  type: GET_WEBSITES_START,
  payload,
});
export const getWebsitesSuccess = (payload) => ({
  payload,
  type: GET_WEBSITES_SUCCESS,
});
export const getWebsitesFail = () => ({ type: GET_WEBSITES_FAIL });

export const getWebsite = (payload) => ({ payload, type: GET_WEBSITE_REQUEST });
export const getWebsiteStart = (payload) => ({
  type: GET_WEBSITE_START,
  payload,
});
export const getWebsiteSuccess = (payload) => ({
  payload,
  type: GET_WEBSITE_SUCCESS,
});
export const getWebsiteFail = () => ({ type: GET_WEBSITE_FAIL });

export const setDealer = (payload) => ({ payload, type: SET_DEALER });
